"use strict";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { composeBreakpoints, wrapStyles } from "../utils.js";
const baseStyles = css`
  margin: 0 auto;
  width: 100%;
`;
const createGutterStyles = (theme, grid) => {
  const styles = `
      max-width: ${grid.maxWidth};
      padding-left: calc(${grid.gutter} / 2);
      padding-right: calc(${grid.gutter} / 2);
    `;
  return wrapStyles(theme, grid.breakpoint, styles);
};
const gutterStyles = ({ theme }) => composeBreakpoints(createGutterStyles, theme, theme.grid);
const Grid = styled("div")(baseStyles, gutterStyles);
export {
  Grid
};
